import {
  Avatar,
  Button,
  CircularProgress,
  IconButton,
  ListItemText,
  MenuItem,
  TextField
} from '@material-ui/core'
import {
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import { AttachmentIcon, CloseIcon, SearchIcon } from 'asterX-UI/Icons'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  CERTIFICATE,
  COMM_DIRECTOR,
  DISCOUNT_REASON,
  EMPLOYEE,
  EXTRA,
  extraOptions,
  PROMO,
  ROMAN_GRABINSKI,
  TRADEIN
} from 'constants/discountTypes'
import { useResErrors } from 'hooks'
import { CarService, SalesService } from 'lib/api'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useSnackbar } from 'notistack'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { useModalbar } from 'modules/Modalbar'
import Lightbox from 'react-18-image-lightbox'
import AutoCompleteField from 'asterX-UI/Inputs/AutoCompleteField'
import { mathCeil } from 'lib/utils'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import { useAuthStore } from 'context/AuthStore'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  btns: {
    display: 'flex',
    gap: 12,
    marginTop: 32,
    fontSize: 14
  },
  round: {
    width: 70,
    height: 70,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '8px solid' + SUCCESS_COLORS['50'],
    backgroundColor: SUCCESS_COLORS['100'],
    margin: 'auto',
    marginBottom: 20
  },
  successText: {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center'
  },
  cross: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  row: {
    display: 'flex',
    gap: 12
  },
  discount: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    marginBottom: 20,
    marginTop: 20,
    fontSize: 14,
    fontWeight: 500
  },
  price: {
    padding: '3px 6px',
    backgroundColor: WARNING_COLORS['300'],
    borderRadius: 5
  },
  certificate: {
    display: 'flex',
    alignItems: 'center'
  },
  extra: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8
  },
  lupa: {
    color: PRIMARY_COLORS['700'],
    fontSize: 24,
    padding: 10,
    backgroundColor: PRIMARY_COLORS['50'],
    borderRadius: 8
  },
  employee: {
    display: 'flex',
    alignItems: 'center'
  },
  topMgmt: {
    display: 'flex',
    alignItems: 'center'
  }
}))
const DiscountModal = ({ onClose }) => {
  const classes = useStyles()
  const { standardCheck, silentCheck } = useResErrors()
  const { enqueueSnackbar } = useSnackbar()
  const {
    authStore: { user }
  } = useAuthStore()
  const {
    store: { sale },
    funcs: { sendDiscountValue }
  } = useSelectionStore()
  const car = sale?.selectedCarsForSale?.[0]
  const { callModalbar } = useModalbar()
  const [discountValue, setDiscountValue] = useState(car.discountValue || 0)
  const [discountAmount, setDiscountAmount] = useState(car.discountAmount || 0)
  const [discountMargin, setDiscountMargin] = useState(car.discountMargin || 0)
  const [discountPhotos, setDiscountPhotos] = useState(
    car?.discountPhotos || []
  )
  const [discountReason, setDiscountReason] = useState(
    car?.discountReason || null
  )
  const [extraReason, setExtraReason] = useState(car?.marginReason || null)
  const [inputedVin, setInputedVin] = useState(sale?.tradeInCarVin || '')
  const [selectedVin, setSelectedVin] = useState(sale?.tradeInCarVin || '')
  const [loadingCarList, setLoadingCarList] = useState(false)
  const [carList, setCarList] = useState([])
  const [photoIndex, setPhotoIndex] = useState(null)
  const [loading, setLoading] = useState(false)
  const [isCertValid, setCertValid] = useState(false)
  const [certNo, setCertNo] = useState('')
  const [error, setError] = useState('')

  const discountOptions = [
    { value: CERTIFICATE, label: DISCOUNT_REASON[CERTIFICATE] },
    { value: COMM_DIRECTOR, label: DISCOUNT_REASON[COMM_DIRECTOR] },
    { value: EXTRA, label: DISCOUNT_REASON[EXTRA] },
    { value: EMPLOYEE, label: DISCOUNT_REASON[EMPLOYEE] },
    { value: ROMAN_GRABINSKI, label: DISCOUNT_REASON[ROMAN_GRABINSKI] }
  ]

  const calculateNds = () => {
    return (car?.price - discountAmount) * 0.12 || 0
  }

  useEffect(() => {
    handleChangeDiscount(discountAmount, discountMargin)
  }, [discountAmount, discountMargin])

  useEffect(() => {
    if (error) {
      callModalbar('title', error, {
        variant: 'warning',
        btnText: 'Понятно',
        onCloseAction: () => setError('')
      })
    }
  }, [error])

  useEffect(() => {
    onSearchCar()
  }, [inputedVin])

  useEffect(() => {
    const newOption = { value: 'OVER_SECRET_DAD', label: 'Овер секрет отца' }
    if (
      [
        'ALA_BESAGASH',
        'ASTANA',
        'SHYMKENT',
        'AST_KAR',
        'ALA_SUYUNBAI'
      ].includes(user?.data?.branch?.code)
    ) {
      const optionExists = extraOptions.some(
        option => option?.value === newOption?.value
      )
      if (!optionExists) {
        extraOptions.push(newOption)
      }
    }
  }, [user])

  useEffect(() => {
    if (extraReason === 'OVER_SECRET_DAD') {
      setDiscountMargin(150000)
    }
    if (extraReason === 'OVER_NDS') {
      const overNds = calculateNds()
      setDiscountMargin(overNds)
    }
  }, [extraReason, discountAmount])

  const handleChangeDiscount = (amount = 0, margin = 0, price = car?.price) => {
    setDiscountValue(
      Number(price || 0) -
        Number(amount || discountAmount) +
        Number(margin || discountMargin)
    )
  }
  const handleChangeDiscountAmount = event => {
    const { value } = event.target
    if (value === '' || value === null) return setDiscountAmount(0)
    setDiscountAmount(value.toString().toNum())
  }
  const handleChangeDiscountMargin = event => {
    const { value } = event.target
    if (value === '' || value === null) return setDiscountMargin(0)
    setDiscountMargin(value.toString().toNum())
  }
  const handleChangeCertNo = event => {
    const { value } = event.target
    setCertNo(value?.toString()?.toNum())
  }
  const handleSelectTradeIn = e => {
    const { value } = e.target
    setInputedVin(value)
    setSelectedVin(value)
    const discount = mathCeil(Number(car?.price || 0) * 0.02, 1)
    setDiscountAmount(discount)
    handleChangeDiscount(
      discount,
      discountMargin.toString()?.replace(/[^0-9]/g, '')
    )
  }
  const handleChangeDiscountReason = event => {
    const { value } = event.target
    setDiscountReason(value)
    setDiscountAmount(0)
    if ([CERTIFICATE, COMM_DIRECTOR, PROMO, EMPLOYEE].includes(value)) {
      if ([CERTIFICATE, PROMO].includes(value)) {
        setCertNo('')
      }
      if ([CERTIFICATE].includes(value)) {
        setExtraReason(null)
      }
      setDiscountPhotos([])
      return setSelectedVin('')
    }

    return setCertNo('')
  }

  const handleChangeExtraReason = event => {
    const { value } = event.target
    setExtraReason(value)
  }

  const handleSearchCert = async () => {
    setLoading(true)
    await SalesService.getCertForCar(certNo).then(res =>
      standardCheck(res, () => {
        const nominal = res?.data?.length > 0 && res.data[0].nominal
        if (nominal) {
          setCertValid(true)
          setDiscountAmount(50000)
        } else {
          setCertValid(false)
          setError(`Сертификат не найден!`)
        }
      })
    )

    setLoading(false)
  }

  const handleSubmit = async () => {
    if (!discountReason) {
      setError('Выберите причину скидки')

      return
    }
    if (
      [CERTIFICATE, COMM_DIRECTOR, EMPLOYEE].includes(discountReason) &&
      discountPhotos?.length === 0
    ) {
      setError('Необходимо загрузить фото')

      return
    }
    if (discountReason === TRADEIN && !selectedVin) {
      setError('Необходимо выбрать автомобиль')

      return
    }
    setLoading(true)
    try {
      const data = {
        discountValue: String(discountValue).replace(/[^0-9]/g, ''),
        discountAmount: discountAmount,
        discountMargin: discountMargin,
        certNo: (isCertValid && certNo) || undefined,
        discountReason,
        tradeInCarVins: selectedVin ? [selectedVin] : [],
        discountPhotos,
        marginReason: extraReason || undefined
      }
      await sendDiscountValue(data)
      enqueueSnackbar('Запрос на скидку отправлен!', { variant: 'success' })
      onClose()
    } catch (error) {
      setError(error.message)
    }
    setLoading(false)
  }

  const handleReject = async () => {
    setLoading(true)
    try {
      await sendDiscountValue(car, -1)
      enqueueSnackbar('Запрос на скидку отменен!')
      onClose()
    } catch (error) {
      setError(error)
    }
    setLoading(false)
  }

  const onUploadPhoto = src => {
    setDiscountPhotos(prevState => [...prevState, src])
  }

  const onSearchCar = async () => {
    if (inputedVin.length < 3) {
      return setLoadingCarList(false)
    }
    setLoadingCarList(true)
    await CarService.getCarList(
      {
        vin: inputedVin,
        statusCodes: ['ppp', 'cp', 're_cp', 'available', 'reserved']
      },
      0,
      4
    ).then(res =>
      silentCheck(res, () => {
        setCarList(res.data.listCars)
      })
    )
    setLoadingCarList(false)
  }
  const handleChangeTradeIn = async vin => {
    setInputedVin(vin)
    setLoadingCarList(true)
  }
  let isReadOnly = false
  let title = 'Запросить скидку'
  let subtitle
  if (car.discountValue && car.discountApprovedByRop === null) {
    isReadOnly = true
    title = 'Скидка на согласовании'
  }

  if (car.discountValue && !!car.discountApprovedByRop) {
    isReadOnly = true
    title = 'Скидка согласована'
  }

  if (car.discountValue && car.discountApprovedByRop === false) {
    title = 'Скидка отказана'
    subtitle = 'Вы можете запросить скидку повторно'
  }
  const handleOpenPhotos = indx => () => {
    setPhotoIndex(indx)
  }

  return (
    <PageContainerDesktop
      customHeader={
        <div className={classes.header}>
          <div className={classes.heading}>Запросить скидку</div>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <LoaderBackdrop loading={loading} />
      <TextField
        label={'Причина скидки'}
        select
        fullWidth
        style={{ marginBottom: 20 }}
        value={discountReason}
        onChange={handleChangeDiscountReason}
      >
        {discountOptions.map(el => (
          <MenuItem key={el.value} value={el.value}>
            <ListItemText primary={el.label} />
          </MenuItem>
        ))}
      </TextField>

      {discountReason === TRADEIN && (
        <div className={classes.tradeIn}>
          <AutoCompleteField
            label={'VIN Trade-In'}
            fullWidth
            value={selectedVin}
            onInput={({ target: { value } }) => handleChangeTradeIn(value)}
            onChange={handleSelectTradeIn}
            loading={loadingCarList}
            options={carList}
            valueKey={'vin'}
            labelKey={'vin'}
            name={'markaNew'}
          />
        </div>
      )}
      {discountReason === EXTRA && (
        <div className={classes.extra}>
          <TextField
            label={'Причина наценки'}
            select
            fullWidth
            value={extraReason}
            onChange={handleChangeExtraReason}
          >
            {extraOptions.map(el => (
              <MenuItem key={el.value} value={el.value}>
                <ListItemText primary={el.label} />
              </MenuItem>
            ))}
          </TextField>
          <AttachPhoto onUpload={onUploadPhoto} disabled={isReadOnly} />
        </div>
      )}
      {discountReason === CERTIFICATE && (
        <div className={classes.certificate}>
          <TextField
            label={'№ сертификата'}
            fullWidth
            value={certNo}
            onChange={handleChangeCertNo}
          />
          <IconButton disabled={certNo.length === 0} onClick={handleSearchCert}>
            {loading ? (
              <CircularProgress size={'12px'} />
            ) : (
              <SearchIcon className={classes.lupa} />
            )}
          </IconButton>
          <AttachPhoto onUpload={onUploadPhoto} disabled={isReadOnly} />
        </div>
      )}
      {[COMM_DIRECTOR, PROMO, EMPLOYEE, ROMAN_GRABINSKI].includes(
        discountReason
      ) && (
        <>
          <div className={classes.topMgmt}>
            <TextField
              label={'Сумма скидки'}
              disabled={isReadOnly}
              name="discount"
              value={discountAmount}
              onChange={handleChangeDiscountAmount}
              fullWidth
            />
            <AttachPhoto onUpload={onUploadPhoto} disabled={isReadOnly} />
          </div>
          <div className={classes.extra}>
            <TextField
              label={'Причина наценки'}
              select
              fullWidth
              value={extraReason}
              onChange={handleChangeExtraReason}
            >
              {extraOptions.map(el => (
                <MenuItem key={el.value} value={el.value}>
                  <ListItemText primary={el.label} />
                </MenuItem>
              ))}
            </TextField>
          </div>
        </>
      )}

      {[CERTIFICATE, TRADEIN].includes(discountReason) && (
        <SumDiscount value={discountAmount} />
      )}
      {discountPhotos.length > 0 && (
        <div
          style={{
            display: 'flex',
            marginBottom: 10
          }}
        >
          {discountPhotos?.map((photo, index) => (
            <Avatar key={index} src={photo} onClick={handleOpenPhotos(index)} />
          ))}
        </div>
      )}
      {discountReason && (
        <div className={classes.row}>
          <TextField
            fullWidth
            label={'Наценка'}
            disabled={isReadOnly}
            value={discountMargin}
            onChange={handleChangeDiscountMargin}
          />
          <TextField
            disabled={true}
            fullWidth
            value={discountValue?.toString()?.thousandSeparator()}
            label={isReadOnly ? 'Сумма на согласовании' : 'Новая цена'}
          />
        </div>
      )}
      <div className={classes.btns}>
        <Button
          variant={'contained'}
          fullWidth
          size={'small'}
          onClick={handleReject}
        >
          Отмена
        </Button>
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          size={'small'}
          onClick={handleSubmit}
        >
          Запросить
        </Button>
      </div>
      {photoIndex !== null && discountPhotos?.length > 0 && (
        <Lightbox
          reactModalStyle={{
            content: { zIndex: 1400 },
            overlay: { zIndex: 1400 }
          }}
          mainSrc={discountPhotos[photoIndex]}
          nextSrc={discountPhotos[(photoIndex + 1) % discountPhotos.length]}
          prevSrc={
            discountPhotos[
              (photoIndex + discountPhotos.length - 1) % discountPhotos.length
            ]
          }
          onCloseRequest={() => setPhotoIndex(null)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + discountPhotos.length - 1) % discountPhotos.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % discountPhotos.length)
          }
        />
      )}
    </PageContainerDesktop>
  )
}

export default DiscountModal
const AttachPhoto = ({ onUpload = () => {}, disabled = false }) => {
  const { standardCheck } = useResErrors()
  const [loading, setLoading] = useState(false)
  const handleUploadFile = e => {
    const files = e.target.files
    if (files) {
      if (files.length !== 0) {
        const file = files[0]
        setLoading(true)
        SalesService.uploadFiles(file).then(res => {
          setLoading(false)
          standardCheck(res, () => {
            onUpload(res.data.fileDownloadUri)
          })
        })
      }
    }
  }
  return (
    <>
      <LoaderBackdrop loading={loading} />
      <IconButton component="label" disabled={disabled}>
        <AttachmentIcon
          style={{
            color: PRIMARY_COLORS['700'],
            padding: 10,
            fontSize: 24
          }}
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleUploadFile}
          hidden
        />
      </IconButton>
    </>
  )
}

const SumDiscount = ({ value }) => {
  const classes = useStyles()
  return (
    <div className={classes.discount}>
      <div>Скидка</div>
      <div className={classes.price}>
        {value?.toString()?.thousandSeparator() || 0} ₸
      </div>
    </div>
  )
}
